module.exports = [{"bankCode":"HBBJ","bankName":"北京密云汇丰村镇银行"},{"bankCode":"HBCD","bankName":"重庆大足汇丰村镇银行"},{"bankCode":"HBCF","bankName":"重庆丰都汇丰村镇银行"},{"bankCode":"HBCQ","bankName":"重庆荣昌汇丰村镇银行"},{"bankCode":"HBDP","bankName":"大连普兰店汇丰村镇银行"},{"bankCode":"HBFU","bankName":"福建永安汇丰村镇银行"},{"bankCode":"HBMC","bankName":"湖北麻城汇丰村镇银行"},{"bankCode":"HBCB","bankName":"湖北随州曾都汇丰村镇银行"},{"bankCode":"HBHT","bankName":"湖北天门汇丰村镇银行"},{"bankCode":"HBHU","bankName":"湖南平江汇丰村镇银行"},{"bankCode":"HBSD","bankName":"山东荣成汇丰村镇银行"},{"bankCode":"HBGD","bankName":"广东恩平汇丰村镇银行"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/api/bank.json
// module id = 887/
// module chunks = 1